import React from 'react';

import { Timeline, Icon} from 'rsuite';

import 'rsuite/dist/styles/rsuite-default.css';
import '../css/widget/widget.time.line.css';

class WiegetTimeLine extends React.Component
{
    constructor( props )
    {
        super(props);
    }

    render()
    {
        let { data } = this.props;

        if( data===undefined || data.length===0 )
        {
            return "";
        }

        return (
            <div className="widget-time-line">
                <Timeline className="widget-timeline" align="left"> 
                {
                    data.map((item, index) => {

                        if( item.icon!==undefined )
                        {
                            return (
                                <Timeline.Item key={index} time={item.time} dot={<Icon icon={item.icon} size="2x" />}>
                                    <div className="time-line-content">
                                        <div className="time-line-title">{item.title}</div>
                                        <div className="time-line-type">{item.type}</div>
                                        <div className="time-line-item">{item.content}</div>
                                        <div className="time-line-description" style={{textAlign:"center"}}>{item.description}</div>
                                    </div>
                                </Timeline.Item>
                            )
                        }
                        else
                        {
                            return (
                                <Timeline.Item  key={index} time={item.time} >
                                     <div className="time-line-content">
                                        <div className="time-line-title">{item.title}</div>
                                        <div className="time-line-type">{item.type}</div>
                                        <div className="time-line-item">{item.content}</div>
                                        <div className="time-line-description" style={{textAlign:"center"}}>{item.description}</div>
                                    </div>
                                </Timeline.Item>
                            )
                        }
                       
                    })
                }
                </Timeline>
            </div>
        ) 
    }
}

export default WiegetTimeLine